export default __webpack_public_path__ + "static/media/SVCB_without_slogan.9aa682f3.svg";